import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

// Sayfa gezintisinde (ileri/geri, yeniden nav) scroll konumunu KORUR ve geri yükler.
// Konteyner window DEĞİL, Layout'taki <main> (overflow-y-auto) — ref ile verilir.
// Konum pathname+search'e göre sessionStorage'da tutulur → sekme oturumu boyunca
// (reload dahil) kaldığın satıra döner. TEK yerde tanımlı, tüm sayfalarda geçerli.
//
// ⚠️ İKİ ayrı tuzak vardı (ikisi de "bazen oluyor bazen olmuyor" yapıyordu):
//   1) ÇIKIŞTA canlı el.scrollTop kaydediliyordu. Listeden detaya geçince <main> içeriği
//      KISALIR → tarayıcı scrollTop'u 0'a KIRPAR (ve bir scroll olayı doğurur). Çıkışta
//      okunan bu kırpılmış 0, iyi konumu EZİYORDU. Çözüm: yalnız SON İYİ konumu (pos) yaz,
//      ve içerik küçülme (clamp) scroll olayını KAYDETME.
//   2) Geri yükleme sabit ~0,75 sn bütçeliydi; liste async yüklenince (Satınalma Onayları
//      gibi) hedefe ulaşamıyordu. Çözüm: yükseklik hedefe ULAŞANA kadar (ya da oturunca /
//      kullanıcı dokununca / 6 sn tavan) dene.
const KEY = 'app_scrollPos'
const readMap = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || '{}') } catch { return {} } }
const writeMap = (m) => { try { sessionStorage.setItem(KEY, JSON.stringify(m)) } catch { /* kota */ } }
const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now())

export function useScrollRestoration(containerRef) {
  const location = useLocation()
  const key = location.pathname + location.search
  const mapRef = useRef(readMap())

  useEffect(() => {
    const el = containerRef.current
    if (!el) return
    const target = Number(mapRef.current[key]) || 0

    let cancelled = false
    let userMoved = false          // kullanıcı elle kaydırdı → geri yüklemeyi bırak (zıplatma)
    let restoring = target > 0     // restore sürerken programatik scroll'u kaydetme
    let raf = null
    let lastRestoreH = -1
    let stable = 0
    let lastHeight = el.scrollHeight  // içerik küçülme (clamp) tespiti
    let pos = target                  // bu sayfanın SON İYİ scroll konumu (clamp'e karşı sigorta)
    const startedAt = now()

    // GİRİŞ: kayıtlı konumu geri yükle — içerik async büyüdüğü için hedefe ULAŞANA dek dene.
    const restore = () => {
      if (cancelled || userMoved || !containerRef.current) { restoring = false; return }
      const c = containerRef.current
      const h = c.scrollHeight
      if (h === lastRestoreH) stable += 1; else { stable = 0; lastRestoreH = h }
      lastHeight = h
      const max = h - c.clientHeight
      c.scrollTop = Math.min(target, max)
      pos = c.scrollTop
      if (max >= target - 2) { restoring = false; return }            // ulaşıldı
      if (stable > 20) { restoring = false; return }                  // yükseklik oturdu, ulaşılamıyor → pes
      if (now() - startedAt > 6000) { restoring = false; return }     // güvenlik tavanı
      raf = requestAnimationFrame(restore)
    }
    if (restoring) raf = requestAnimationFrame(restore)
    else { el.scrollTop = 0; pos = 0 }

    // Kullanıcı elle kaydırırsa/dokunursa geri yüklemeyi durdur.
    const stopRestore = () => { userMoved = true; restoring = false }
    el.addEventListener('wheel', stopRestore, { passive: true })
    el.addEventListener('touchmove', stopRestore, { passive: true })
    el.addEventListener('keydown', stopRestore)
    el.addEventListener('pointerdown', stopRestore, { passive: true })

    // KAYIT: gerçek kullanıcı kaydırmasını sakla; içerik küçülme (clamp) olayını ATLA.
    let scrollRaf = null
    const onScroll = () => {
      const h = el.scrollHeight
      if (h < lastHeight - 1) { lastHeight = h; return }  // içerik küçüldü → clamp, kaydetme
      lastHeight = h
      if (restoring) return
      pos = el.scrollTop
      if (scrollRaf) return
      scrollRaf = requestAnimationFrame(() => {
        scrollRaf = null
        mapRef.current[key] = pos
        writeMap(mapRef.current)
      })
    }
    el.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      cancelled = true
      if (raf) cancelAnimationFrame(raf)
      if (scrollRaf) cancelAnimationFrame(scrollRaf)
      el.removeEventListener('wheel', stopRestore)
      el.removeEventListener('touchmove', stopRestore)
      el.removeEventListener('keydown', stopRestore)
      el.removeEventListener('pointerdown', stopRestore)
      el.removeEventListener('scroll', onScroll)
      // ÇIKIŞ: SON İYİ konumu yaz — canlı el.scrollTop DEĞİL (içerik küçülüp 0'a kırpılmış olabilir)
      mapRef.current[key] = pos
      writeMap(mapRef.current)
    }
  }, [key, containerRef])
}
